/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import i18next from 'i18next'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import 'react-tabs/style/react-tabs.css'
import swal from 'sweetalert'
import {KTSVG} from '../../../../_metronic/helpers'
import {getAccessesPriceJbp} from '../../../../api/modules/access/access'
import {
  detailPrice,
  getPriceJbpSearch,
  getPricelistBJBImport,
  getRegionAllMasterData,
  getSalesOrgAllMasterData,
  massUpdatePriceJbp,
} from '../../../../api/modules/master-data/master_2'
import {PopoverText} from '../../../../components/Popover/Popover'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'
import {StyledCard} from '../../../../components/StyledCard'
import * as TableUI from '../../../../components/Table/Table'
import {HakAkses} from '../../../../components/mikro/getHakAkses'
import {useRowTable} from '../../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {setJbpDetail} from '../../../../redux/slices/appSlices'
import {
  filterSelector,
  resetFilterNonJBPPrices,
  setFilterNonJBPPrices,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import {fetchNonJBPPrices, headers} from '../../../../services/fetcher'
import {IFetchJBPPriceDetailResponse} from '../../../../services/types'
import {objToParams} from '../../../../utils/objToParams'
import Pagination from '../../component/Pagination'
import {RowFitlerNonJbpPrices} from './RowFilterNonJbpPrices'
import {authSelector} from 'src/redux/slices/authSlices'
import { InputFile } from 'src/app/components/InputFile'

type Props = {
  className: string
}

const TablePriceNonJbp: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterNonJBPPrices} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {t} = useTranslation()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 14,
    onReloadTable: () => handleResetTable(),
  })

  const [btnLoading, setBtnLoading] = useState(false)
  const [price, setPrice] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [isFailed, setIsFailed] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [accesses, setAccesses] = useState<any>()
  const [sorg, setSorg] = useState<any>()
  const [regions, setRegions] = useState<any>()
  const [cities, setCities] = useState<any>()
  const [actived, setActived] = useState(false)

  const rowNumber = useMemo(() => {
    const per = filterNonJBPPrices?.per_page ?? 5
    return page * per - per
  }, [filterNonJBPPrices, page])

  const onFetchNonJBPPrices = useCallback(() => {
    setLoading(true)
    setIsFailed(false)
    fetchNonJBPPrices(filterNonJBPPrices)
      .then((res) => {
        setPrice(res.data.data.data)
        setPage(res.data.data.current_page)
        setNumberURL(res.data.data.links)
      })
      .catch((err) => setIsFailed(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterNonJBPPrices])

  const [arrayID, setArrayID] = useState<any[]>([])

  const updateAllStatus = async (status: any) => {
    const payload = {
      ids: arrayID,
      is_active: status,
      credentials: localStorage.getItem('credential')!,
    }

    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (approved) => {
      if (approved) {
        await massUpdatePriceJbp('jbp', payload)
          .then(async (res: any) => {
            if (status) {
              swal({
                title: t('Harga Non JBP Berhasil di Aktifkan'),
                icon: 'success',
              })
            } else {
              swal({
                title: t('Harga Non JBP Berhasil di Nonaktifkan'),
                icon: 'success',
              })
            }
            setLoading(true)
            setIsFailed(false)
            await getPriceJbpSearch(
              'jbp',
              salesorg,
              salesorgCode,
              custcode,
              custName,
              productName,
              region,
              city,
              searchStatus,
              sellprice,
              dist,
              purchaseprice
            )
              .then((resp: any) => {
                setPrice(resp.data.data.data)
                if (searchStatus != '') {
                  let tempArray: any[] = []
                  res.data.data.data.forEach((data: any) => {
                    tempArray.push(data.id)
                  })
                  setArrayID(tempArray)
                } else {
                  setArrayID([])
                }
                setNumberURL(resp.data.data.links)
              })
              .catch((err: any) => {
                setIsFailed(true)
              })
              .finally(() => {
                setLoading(false)
              })
          })
          .catch((error) => {
            swal({
              title: `${t(error.response.data.message)}`,
              icon: 'error',
            })
            return
          })
      }
    })
  }

  useEffect(() => {
    const getAccessMenu = async () => {
      const res = await getAccessesPriceJbp(roleId)
      setAccesses(res.data.data)
    }

    const getSalesOrg = async () => {
      const res = await getSalesOrgAllMasterData()
      const data = res.data.data
      setSorg(data)
    }

    const getRegion = async () => {
      const res = await getRegionAllMasterData()
      const data = res.data.data
      setRegions(data)
    }

    getRegion()
    getSalesOrg()
    getAccessMenu()
  }, [])

  const paginateNumber = async (url: string) => {
    if (!url) return

    setLoading(true)

    const token = localStorage.getItem('token') as string
    const endpoint = `${url}&type=non-jbp&${objToParams(filterNonJBPPrices)}`
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
    const data = res.data.data

    setPrice(data.data)
    setPage(data.current_page)
    setNumberURL(data.links)
    setLoading(false)
  }

  const [salesOrgCode, setSalesOrgCode] = useState('')
  const [customerCode, setCustomerCode] = useState('')
  const [productCode, setProductCode] = useState('')
  const [regionCode, setRegionCode] = useState('')
  const [cityCode, setCityCode] = useState('')
  const [minimumPrice, setMinimumPrice] = useState('')
  const [sellingPrice, setSellingPrice] = useState<any>()
  const [discount, setDiscount] = useState('')
  const [purchasePrice, setPurchasePrice] = useState<any>()
  const [validFrom, setValidFrom] = useState<any>()
  const [validTo, setValidTo] = useState<any>()
  const [isUpload, setIsUpload] = useState(false)

  const [files, setFiles] = useState({file: null})
  const [showUpload, setShowUpload] = useState(false)
  const [showExport, setShowExport] = useState(false)

  const handleUpload = async () => {
    setBtnLoading(true)
    const lang = i18next.language
    let file = files.file
    let formdata = new FormData()
    formdata.append('file', file!)

    await getPricelistBJBImport(lang, formdata)
      .then(
        (res: any) => {
          swal({
            title: `${t('Harga Non JBP Berhasil di Upload')}`,
            icon: 'success',
          }).then(() => {
            setShowUpload(false)
            // getPrice()
            setActived(!actived)
          })
        },
        (err: any) => {
          swal({
            title: t(err.response.data.message),
            icon: 'error',
          })
        }
      )
      .catch((err: any) => {
        swal({
          title: t(err.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleCheckFile = (url: any) => {
    axios
      .get(url)
      .then((response) => {
        window.open(url)
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
  }

  const downloadTemplate = (cond: any) => {
    const lang = i18next.language
    if (cond == 'region')
      handleCheckFile(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/regions/export?token=${localStorage.getItem('token')}`
      )
    else if (cond == 'sales')
      handleCheckFile(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/sales-org/export?token=${localStorage.getItem('token')}`
      )
    else if (cond == 'list')
      handleCheckFile(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/price-list/jbp/import/template?credentials=${localStorage.getItem(
          'credential'
        )}&token=${localStorage.getItem('token')}`
      )
  }

  const deletePrice = async (id: any) => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        axios
          .delete(
            `${
              process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
            }/price-list/jbp/delete/${id}?credentials=${localStorage.getItem('credential')}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            }
          )
          .then((response) => {
            if (!response.data.error) {
              setIsUpload(true)

              swal({
                title: `${t('Harga Non JBP Berhasil di Hapus')}`,
                icon: 'success',
              }).then(() => {
                // getPrice()
                setActived(!actived)
              })
            }
          })
          .catch((error) => {
            swal({
              title: `${t(error.response.data.message)}`,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleEdit = async (item: IFetchJBPPriceDetailResponse['data']) => {
    if (!item || !item.id) return
    sessionStorage.setItem('jbp-id', item.id.toString())
    sessionStorage.setItem('jbp', 'non-jbp')
    dispatch(setJbpDetail(item))
    navigate('/master/price/non-jbp/edit')
  }

  const [salesorg, setSalesorg] = useState('')
  const [salesorgCode, setSalesorgCode] = useState('')
  const [custcode, setCustcode] = useState('')
  const [custName, setCustName] = useState('')
  const [productcode, setProducecode] = useState('')
  const [productName, setProduceName] = useState('')
  const [region, setRegion] = useState('')
  const [city, setCity] = useState('')
  const [minprice, setMinprice] = useState<any>('')
  const [sellprice, setSellprice] = useState<any>('')
  const [dist, setDist] = useState('')
  const [purchaseprice, setPurchaseprice] = useState<any>('')
  const [searchStatus, setStatus] = useState('')

  useEffect(() => {
    const getData = setTimeout(onFetchNonJBPPrices, 1000)
    return () => clearTimeout(getData)
  }, [onFetchNonJBPPrices])

  const handleAddPrice = async () => {
    sessionStorage.setItem('jbp', 'non-jbp')
    navigate('/master/price/non-jbp/create')
  }

  const [regionDetail, setRegionDetail] = useState(false)
  const [cityDetail, setCityDetail] = useState(false)

  const [detail, setDetail] = useState<any[]>([])
  const handleDetail = async (id: any) => {
    await detailPrice(id).then((res: any) => {
      setDetail(res.data.data.regions)
      setRegionDetail(true)
    })
  }

  const [detailCity, setDetailCity] = useState<any[]>([])
  const handleCiyDetail = async (id: any) => {
    await detailPrice(id).then((res: any) => {
      setDetailCity(res.data.data.cities)
      setCityDetail(true)
    })
  }

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterNonJBPPrices({...filterNonJBPPrices, per_page: value ?? 5}))
  }

  const handleResetTable = () => {
    dispatch(resetFilterNonJBPPrices())
  }

  useEffect(() => {
    return () => {
      handleResetTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterNonJBPPrices?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
        rightContent={
          hakAkses?.create && (
            <>
              <button
                hidden={searchStatus == 'false' ? false : true}
                className='btn btn-success me-2'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('Active All')}
                onClick={() => updateAllStatus(true)}
              >
                {t('Active All')}
              </button>
              <button
                hidden={searchStatus == 'true' ? false : true}
                className='btn btn-danger me-2'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('Inactive All')}
                onClick={() => updateAllStatus(false)}
              >
                {t('Inactive All')}
              </button>
              <button
                className='btn btn-info me-2'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('Download Template')}
                onClick={() => setShowExport(true)}
              >
                <KTSVG path='/media/icons/duotune/download.svg' />
                {t('Download Template')}
              </button>
              <button
                onClick={() => {
                  setShowUpload(true)
                }}
                className='btn btn-warning me-2'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('Import')}
              >
                <KTSVG path='/media/icons/duotune/cloud-arrow-up-fill.svg' />
                {t('Import')}
              </button>
              <div className='d-flex justify-content-end'>
                <button
                  className='btn btn-primary d-flex align-items-center'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title={t('add_price')}
                  onClick={handleAddPrice}
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  {t('order-tambah')}
                </button>
              </div>
            </>
          )
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('Sales Org Code')}</th>
              <th>Sales Org</th>
              <th>{t('Product Code')}</th>
              <th>{t('kontrak-nama')}</th>
              <th>{t('Region Name')}</th>
              <th>{t('City Name')}</th>
              <th>Minimum {t('Harga')}</th>
              <th>{t('Selling Price')}</th>
              <th>{t('Discount')}</th>
              <th>{t('Purchase Price')}</th>
              <th>{t('deskrisi')}</th>
              <th>Status</th>
              <th>{t('order-aksi')}</th>
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFitlerNonJbpPrices />

            {loading ? (
              <RowLoader />
            ) : isFailed ? (
              <RowErrorFetch />
            ) : price?.length === 0 ? (
              <RowEmptyData />
            ) : (
              price?.map((prices, _index) => (
                <tr key={_index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>{prices?.sales_org_code}</td>
                  <td>{prices?.sales_org?.name}</td>
                  <td>{prices?.product_code.slice(-7)}</td>
                  <td>{prices?.pricelist_dasar?.product_name}</td>
                  <td className='cursor-pointer' onClick={() => handleDetail(prices?.id)}>
                    {prices?.regions[0].region_name}
                  </td>
                  <td className='cursor-pointer' onClick={() => handleCiyDetail(prices?.id)}>
                    {prices?.cities[0]?.city_name}
                  </td>
                  <td>
                    Rp
                    {i18next.language === 'en'
                      ? prices?.minimum_price?.toLocaleString('en', {
                          maximumFractionDigits: 4,
                        })
                      : prices?.minimum_price?.toLocaleString('id', {
                          maximumFractionDigits: 4,
                        })}
                  </td>
                  <td>
                    Rp
                    {i18next.language === 'en'
                      ? prices?.selling_price?.toLocaleString('en', {
                          maximumFractionDigits: 4,
                        })
                      : prices?.selling_price?.toLocaleString('id', {
                          maximumFractionDigits: 4,
                        })}
                  </td>
                  <td>{prices?.discount}%</td>
                  <td>
                    Rp
                    {i18next.language === 'en'
                      ? prices?.purchase_price?.toLocaleString('en', {
                          maximumFractionDigits: 4,
                        })
                      : prices?.purchase_price?.toLocaleString('id', {
                          maximumFractionDigits: 4,
                        })}
                  </td>
                  <td>
                    <PopoverText
                      content={prices?.description}
                      index={_index}
                      className='spec-slicee'
                    />
                  </td>
                  <td>
                    <span className='d-block '>
                      {prices?.is_active === false ? (
                        <span className='badge badge-light-danger'>{t('Non-Active')}</span>
                      ) : (
                        <span className='badge badge-light-success'>{t('Active')}</span>
                      )}
                    </span>
                  </td>
                  <td>
                    <div
                      className='d-flex justify-content-center'
                      style={{marginTop: '.5px', marginBottom: '.5px'}}
                    >
                      {hakAkses?.update && (
                        <button
                          onClick={() => handleEdit(prices)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2'
                          title={t('ubah')}
                        >
                          <KTSVG path='/media/icons/duotune/pencil-fill.svg' />
                        </button>
                      )}

                      {hakAkses?.delete && (
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          title={t('Hapus')}
                          onClick={() => deletePrice(prices.id)}
                        >
                          <KTSVG path='/media/icons/duotune/trash-fill.svg' />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showUpload}
        onHide={() => setShowUpload(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Import')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table>
            <tr>
              <td style={{width: '120px'}}>
                <h6>{t('order-fileUnggah')}</h6>
              </td>
              <td className='w-75'>
                <InputFile
                    setFileName={(_: string) => {}}
                    setFiles={setFiles}
                    isBase64={false}
                />
              </td>
            </tr>
          </table>
          <div className='d-flex justify-content-end mt-5'>
            <Button
              variant='primary'
              className='w-100'
              onClick={() => handleUpload()}
              disabled={btnLoading}
            >
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-kirim')
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showExport}
        onHide={() => setShowExport(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Download Template')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex justify-content-center'>
            <button
              className='btn btn-info me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('Download Template')}
              onClick={() => downloadTemplate('region')}
            >
              <KTSVG path='/media/icons/duotune/download.svg' />
              {t('Download Template')} {t('kontrak-wilayah')} & {t('sub-order-kota')}
            </button>
            <button
              className='btn btn-info me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('Download Template')}
              onClick={() => downloadTemplate('sales')}
            >
              <KTSVG path='/media/icons/duotune/download.svg' />
              {t('Download Template')} Sales Org
            </button>
            <button
              className='btn btn-info me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('Download Template')}
              onClick={() => downloadTemplate('list')}
            >
              <KTSVG path='/media/icons/duotune/download.svg' />
              {t('Download Template')} {t('Price List2')} Non JBP
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={regionDetail}
        onHide={() => setRegionDetail(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Region Name')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='mb-4'>
            {detail.map((data, _index) => (
              <>
                <Col md={4}>
                  <div className='mb-3'>
                    <span className='me-2'>•</span>
                    {data.region_name}
                  </div>
                </Col>
              </>
            ))}
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        show={cityDetail}
        onHide={() => setCityDetail(false)}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('City Name')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='mb-4'>
            {detailCity.map((data) => (
              <>
                <Col md={4}>
                  <div className='mb-1'>
                    <span className='me-2'>•</span>
                    {data.city_name}
                  </div>
                </Col>
              </>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TablePriceNonJbp}
